var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'vehiclEviloationTable',
    data: function () {
        return {
            pageNo: 1,
            pageSize: 20,
            totalItemCount: '',
            orderCode: '',
            isPagination: true,
            emptyText: '暂无数据',
            vehicleCount: undefined,
            errorDownloadUrl: '',
            list: null,
            loadingMain: null,
        };
    },
    computed: {
        maxHeight: function () {
            return window.innerHeight - 164;
        },
    },
    props: {
        otherParam: {
            type: Object,
            default: function () {
                return {};
            },
        },
        url: {
            type: String,
            require: true,
        },
        type: {
            type: String,
            default: function () {
                return 'single';
            },
        },
    },
    watch: {
        otherParam: function () {
            this.getData();
        },
    },
    methods: {
        getData: function () {
            var _this = this;
            var _a = this, otherParam = _a.otherParam, url = _a.url;
            var data = Object.assign(__assign({ pageNo: this.pageNo, pageSize: this.pageSize }, otherParam));
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.$request({
                url: url,
                method: 'post',
                data: data,
                loadingControl: 'hand',
            }).then(function (res) {
                _this.vehicleCount = undefined;
                if (!res || res.errorCode)
                    return _this.loadingMain.close();
                var _a = res.data, orderCode = _a.orderCode, success = _a.success, vehicleCount = _a.vehicleCount, errorDownloadUrl = _a.errorDownloadUrl;
                _this.orderCode = orderCode;
                if (!success) {
                    _this.viewList({
                        pageNo: 1,
                        pageSize: 20,
                        totalItemCount: 0,
                        data: [],
                        preStatus: 'fail',
                        vehicleCount: vehicleCount,
                        errorDownloadUrl: errorDownloadUrl,
                    }, orderCode);
                    return;
                }
                if (typeof orderCode === 'string') {
                    _this.getProgress(orderCode);
                }
                else {
                    _this.viewList({
                        pageNo: 1,
                        pageSize: 20,
                        totalItemCount: 0,
                        preStatus: 'fail',
                        data: [],
                        vehicleCount: vehicleCount,
                        errorDownloadUrl: errorDownloadUrl,
                    }, orderCode);
                }
            });
        },
        getProgress: function (asyncKey) {
            var _this = this;
            var pollingMain = function () {
                _this.getProgressStatus(asyncKey).then(function (res) {
                    if (!res || res.errorCode)
                        return _this.loadingMain.close();
                    if (!res.finished)
                        return (timer = setTimeout(function () {
                            pollingMain();
                        }, 500));
                    _this.viewList(res, _this.orderCode);
                    clearTimeout(timer);
                });
            };
            var timer = null;
            pollingMain();
        },
        getProgressStatus: function (asyncKey) {
            return this.$request({
                url: '/proxy/vehicle/driver/violation/batch/async/fetch/progress',
                method: 'post',
                data: {
                    orderCode: asyncKey,
                    pageSize: this.pageSize,
                    pageNo: this.pageNo,
                },
                loadingControl: 'hand',
            });
        },
        viewList: function (res, asyncKey) {
            var pageNo = res.pageNo, pageSize = res.pageSize, totalItemCount = res.totalItemCount, data = res.data, preStatus = res.preStatus, vehicleCount = res.vehicleCount, errorDownloadUrl = res.errorDownloadUrl;
            this.pageNo = pageNo;
            this.pageSize = pageSize;
            this.totalItemCount = totalItemCount;
            this.list = data;
            this.vehicleCount = vehicleCount;
            this.list.length === 0 && (this.emptyText = '恭喜，暂时没有违章记录');
            this.type === 'batch' &&
                preStatus !== 'fail' &&
                vehicleCount === 0 &&
                this.importVehicle();
            this.errorDownloadUrl = errorDownloadUrl;
            this.$emit('get-asynckey', {
                asyncKey: asyncKey,
            });
            this.loadingMain.close();
        },
        sizeChange: function (val) {
            var orderCode = this.orderCode;
            this.pageSize = val;
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.getProgress(orderCode);
        },
        currentChange: function (val) {
            var orderCode = this.orderCode;
            this.pageNo = val;
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.getProgress(orderCode);
        },
        formatterHappenTime: function (row, column, cellValue, index) {
            return moment(cellValue).format('YYYY-MM-DD HH:mm:ss');
        },
        formatterPunishCount: function (row, column, cellValue, index) {
            return toYuan(cellValue).toFixed(2);
        },
        formatterContractStatus: function (row, column, cellValue, index) {
            var dict = {
                INACTIVE: '未开始',
                ACTIVE: '进行中',
                TERMINATED: '已结束',
            };
            return cellValue ? dict[cellValue] : '--';
        },
        formatterUpdateTime: function (row, column, cellValue, index) {
            return moment(cellValue).format('YYYY-MM-DD HH:mm:ss');
        },
        formatterStatus: function (row, column, cellValue, index) {
            var dict = {
                UNTREATED: '未处理',
                PROCESSED: '已处理',
            };
            return cellValue ? dict[cellValue] : '--';
        },
        formatterIsempty: function (row, column, cellValue, index) {
            return cellValue ? cellValue : '--';
        },
        cellStyle: function (_a) {
            var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
            if (columnIndex === 12 && row.status === 'UNTREATED') {
                return 'color:#FF5257';
            }
        },
        importVehicle: function () {
            var _this = this;
            this.$confirm('', '', {
                message: '<p class="title">暂无已导入车辆，无法查询</p><p>您还未曾导入过车辆，是否先导入车辆？</p>',
                dangerouslyUseHTMLString: true,
                showClose: true,
                confirmButtonText: '立即导入',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(function (res) {
                _this.$router.push({ name: 'vehicleImport' });
            })
                .catch(function () { });
        },
    },
});
